module.exports = __webpack_public_path__ + "static/media/BadgeTB.5de77065.svg";